import React from 'react'
import { newBtnStyle, typoStyle } from "../styles/globalStyle"
import Typography from '@mui/material/Typography';
import { Box, TextField } from '@mui/material';
import OtomatikTornaModal from '../components/modals/OtomatikTornaModal';
import useArge from '../hooks/useArge';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import DeleteModals from '../components/deleteModals/DeleteModals';
import OtomatikTorna_DataTable from '../components/tables/OtomatikTorna_DataTable';
import { HiOutlineSearch } from "react-icons/hi";
import { toastWarnNotify } from '../helpers/ToastNotify';

const Otomatiktorna = () => {


  let getVardiya = 0;

  const { getMaterialCenter, getWorkCenter, getFireData } = useArge()
  const { workCenterCode, materialCode, otoTornaData, loading } = useSelector((state) => state.arge)

  const { currentUser } = useSelector((state) => state.auth)

  const [averages, setAverages] = useState({
    agirlik: 0,
    taban: 0,
    kenar: 0,
    pkenar: 0,
    cap: 0,
  });

  const [infoDate, setInfoDate] = useState({
    dateFrom: "",
    dateTo: ""
  })

  const getShift = () => {
    //! padStart(2,'0') metodu ile hedefUzunluk ve eklenecek karakterler olarak iki parametre alır.
    const hour = new Date().getHours().toString().padStart(2, '0')

    if (hour > 8 && hour < 16) {
      getVardiya = 2
    }
    else if (hour > 16 && hour < 23) {
      getVardiya = 3
    }
    else {
      getVardiya = 1
    }

    return getVardiya

  }



  const [info, setInfo] = useState({
    department: "Sekillendirme",
    type: "OtomatikTorna",
    is_merkezi: "",
    agirlik: "",
    taban: "",
    kenar: "",
    pkenar: "",
    cap: "",
    aynacap: "",
    kulpbunye: "",
    kesilensucuk: "",
    kirpintimiktar: "",
    camursert: "",
    catlakkontrol: "",
    rotuskontrol: "",
    yuzeykontrol: "",
    uygunsuzluktipi: "",
    aciklama: "",
    vardiyasorumlusu: "",
    kelepenozulkontrol: "",
    havakontrol: "",
    urun_kodu: "",
    oldData_date: "",

    kulpBunyeBukum: "",
    kurutmaSicakligi: "",
    sablonDevirHizi: "",
    sucukHavaKontrol: "",

    vardiya: getShift(),
    date: "",
    time: "",
    kontroleden_kisi: currentUser,
    newMaterialName: ""
  })


  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false)
    setInfo({
      type: "OtomatikTorna",
      is_merkezi: "",
      agirlik: "",
      taban: "",
      kenar: "",
      pkenar: "",
      cap: "",
      aynacap: "",
      kulpbunye: "",
      kesilensucuk: "",
      kirpintimiktar: "",
      camursert: "",
      catlakkontrol: "",
      rotuskontrol: "",
      yuzeykontrol: "",
      uygunsuzluktipi: "",
      aciklama: "",
      vardiyasorumlusu: "",
      kelepenozulkontrol: "",
      havakontrol: "",
      urun_kodu: "",
      oldData_date: "",
      kulpBunyeBukum: "",
      kurutmaSicakligi: "",
      sablonDevirHizi: "",
      sucukHavaKontrol: "",
      vardiya: getShift(),
      date: "",
      time: "",
      kontroleden_kisi: currentUser,
      newMaterialName: ""
    })
  }

  const [delOpen, setdelOpen] = React.useState(false);
  const delHandleOpen = () => setdelOpen(true);
  const delHandleClose = () => setdelOpen(false);




  useEffect(() => {

    getMaterialCenter()
    getWorkCenter()

    getFireData("OtomatikTorna")

  }, [])



  // istatistik datasındaki ortalama hesaplamasını yapar
  useEffect(() => {
    const dizi = Object.keys(otoTornaData).map(key => { return { id: key, ...otoTornaData[key] } })
    dizi.sort((a, b) => {
      const convertDateTime = (date, time) => {
        if (!date || !time) {
          return new Date(0); // 1 Ocak 1970
        }
        const [day, month, year] = date.split('-').map(num => num.padStart(2, '0'));
        const [hours, minutes] = time.split(':').map(num => num.padStart(2, '0'));
        return new Date(`${year}-${month}-${day}T${hours}:${minutes}:00`);
      };

      const dateTimeA = convertDateTime(a.date, a.time);
      const dateTimeB = convertDateTime(b.date, b.time);

      return dateTimeB - dateTimeA;
    });

    // Ortalama hesaplamaları
    const total = {
      agirlik: 0,
      taban: 0,
      kenar: 0,
      pkenar: 0,
      cap: 0,
    };
    const count = dizi.length;

    dizi.forEach(item => {
      total.agirlik += parseFloat(item.agirlik) || 0;
      total.taban += parseFloat(item.taban) || 0;
      total.kenar += parseFloat(item.kenar) || 0;
      total.pkenar += parseFloat(item.pkenar) || 0;
      total.cap += parseFloat(item.cap) || 0;
    });

    const averages = {
      agirlik: (total.agirlik / count).toFixed(2),
      taban: (total.taban / count).toFixed(2),
      kenar: (total.kenar / count).toFixed(2),
      pkenar: (total.pkenar / count).toFixed(2),
      cap: (total.cap / count).toFixed(2),
    };

    // setpresData(dizi);
    setAverages(averages); // Ortalamaları state'e kaydediyoruz
  }, [otoTornaData]);



  const handleChangeDate = (e) => {
    const { name, value } = e.target
    setInfoDate({ ...infoDate, [name]: value })
  }

  const handleDateFilter = () => {

    if (infoDate.dateFrom && infoDate.dateTo) {

      //! tarih filtreleme işleminde son seçilen sarih bilgisi localStorage taragında saklanır.
      // localStorage.setItem('lastSelectedDate', JSON.stringify(info))

      getFireData('OtomatikTorna', infoDate.dateFrom, infoDate.dateTo)

    }
    else {
      toastWarnNotify('Tarih bilgisini kontrol ediniz !')
    }

  }



  const averageStyle = {
    border: '1px solid #758694',
    color: '#ffffff',
    backgroundColor: '#758694',
    padding: 3,
    borderRadius: 3,
    fontSize: 14
  }


  return (


    <div>
      <Typography mt={8} align='center' variant='h5' fontWeight={700} sx={typoStyle}>
        Otomaik Torna
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

        <Box>
          <Button onClick={handleOpen} variant='outlined' sx={newBtnStyle}>New</Button>
        </Box>


        <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 1, alignItems: 'center', p: 2 }}>
          <Typography>From</Typography>
          <TextField
            required
            id='dateFrom'
            name='dateFrom'
            type='date'
            value={infoDate.dateFrom}
            onChange={handleChangeDate}
          />

          <Typography>To</Typography>
          <TextField
            required
            id='dateTo'
            name='dateTo'
            type='date'
            value={infoDate.dateTo}
            onChange={handleChangeDate}
          />
          <HiOutlineSearch size={30} color='black' onClick={handleDateFilter} cursor={'pointer'} style={{ marginLeft: 15 }} />
        </Box>

      </Box>

      <OtomatikTornaModal open={open} handleClose={handleClose} info={info} setInfo={setInfo} workCenterCode={workCenterCode} materialCode={materialCode} />

      <DeleteModals delOpen={delOpen} delHandleClose={delHandleClose} delHandleOpen={delHandleOpen} setdelOpen={setdelOpen} info={info} />



      <Box>
        {
          loading ?
            (
              <Typography>Loading..</Typography>
            )
            :
            (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>

                  <Typography style={averageStyle}>Ağırlık : {averages.agirlik}</Typography>
                  <Typography style={averageStyle}>Çap : {averages.cap}</Typography>
                  <Typography style={averageStyle}>Kenar : {averages.kenar}</Typography>
                  <Typography style={averageStyle}>Pkenar : {averages.pkenar}</Typography>
                  <Typography style={averageStyle}>Taban : {averages.taban}</Typography>

                </Box>

                <OtomatikTorna_DataTable handleOpen={handleOpen} delHandleOpen={delHandleOpen} setInfo={setInfo} info={info} otoTornaData={otoTornaData} />

              </Box>
            )
        }
      </Box>

    </div>



  )
}

export default Otomatiktorna